import Vue from 'vue';
import VueRouter from 'vue-router';
import Plain from '@/views/layouts/Plain.vue';
import Main from '@/views/layouts/Main.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: '404',
    meta: {
      title: 'Stránka nenalezena',
      layout: Main,
    },
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
  {
    path: '/403',
    name: '403',
    meta: {
      title: 'Přístup odepřen',
      layout: Plain,
    },
    component: () => import(/* webpackChunkName: "403" */ '@/views/403.vue'),
  },
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Stavy tiskáren',
      requiresAuth: true,
      layout: Main,
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Přihlášení',
      layout: Plain,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/printers',
    component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
    meta: {
      title: 'Přehled tiskáren',
      requiresAuth: true,
      layout: Main,
    },
    children: [
      {
        path: '/printers',
        name: 'printers',
        meta: {
          title: 'Přehled tiskáren',
          requiresAuth: true,
          layout: Main,
        },
        component: () => import(/* webpackChunkName: "printers" */ '@/views/printers/PrintersAll.vue'),
      },
      {
        path: ':serialNumber',
        name: 'printers.detail',
        meta: {
          parent: 'printers',
          title: 'Detail tiskárny',
          requiresAuth: true,
          layout: Main,
        },
        component: () => import(/* webpackChunkName: "printerDetail" */ '@/views/printers/PrinterDetail.vue'),
      },
    ],
  },
  {
    path: '/customer',
    component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
    meta: {
      title: 'Přehled tiskáren',
      requiresAuth: true,
      layout: Main,
    },
    children: [
      {
        path: '/customer/:code/404',
        name: 'customer404',
        meta: {
          title: 'Stránka nenalezena',
          layout: Main,
        },
        component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      },
      {
        path: '/customer/:code/403',
        name: 'customer403',
        meta: {
          title: 'Přístup odepřen',
          layout: Plain,
        },
        component: () => import(/* webpackChunkName: "403" */ '@/views/403.vue'),
      },
      {
        path: ':code',
        name: 'customer.printers',
        meta: {
          title: 'Přehled tiskáren',
          requiresAuth: true,
          layout: Main,
        },
        component: () => import(/* webpackChunkName: "customerPrinters" */ '@/views/customer/printers/CustomerPrintersAll.vue'),
      },
      {
        path: ':code/:serialNumber',
        name: 'customer.printers.detail',
        meta: {
          parent: 'customer.printers',
          title: 'Detail tiskárny',
          requiresAuth: true,
          layout: Main,
        },
        component: () => import(/* webpackChunkName: "customerPrinterDetail" */ '@/views/customer/printers/CustomerPrinterDetail.vue'),
      },
    ],
  },
];

// eslint-disable-next-line
const scrollBehavior = (to, from, savedPosition) => {
  return {
    x: 0,
    y: 0,
  };
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
});

export default router;
